import { type CustomerDTO } from "@ifa/utils";
import { HistoryOrderSection } from "../../CustomerDetail/components/history/HistoryOrderSection";

interface HistoryOrderViewProps {
  customer: CustomerDTO | null;
  onBack: () => void;
}

export function HistoryOrderView({ customer }: HistoryOrderViewProps) {
  return (
    <div style={{
      height: "100%",
      overflow: "auto",
    }}>
      <HistoryOrderSection
        customer={customer}
        onRefresh={() => {}}
        fromCustomerList={true}
        customerId={customer?.customerId}
      />
    </div>
  );
}
